module.exports = __webpack_public_path__ + "img/image_4.12d1d721.jpg";